export const environment = {
  production: false,
  mobile: false,
  CLIENT_COLLECTION: "clients",
  ADMIN_COLLECTION: "admins",
  TASK_COLLECTION: "tasks",
  CONFIG_COLLECTION: "configs",
  BUILTIN_COLLECTION: "builtins",
  STOPWORD_DOCUMENT: "stopword",
  STOPWORD_WHITELIST_DOCUMENT: "stopwordWhitelist",
  VERBAL_DOCUMENT: "verbal",
  SYSTEM_DOCUMENT: "system",
  FRIDAY_ID: "friday",
  FRIDAY_ADMIN_TOKEN: "automagicbotadmin",
  FRIDAY_API_TOKEN: "automagicbot",
};
